import z from 'zod';

import { OrganizationRelationType } from '@evimo/types/enums/organization-relation-type';
export { OrganizationRelationType };

export const organisationRelationshipPropsSchema = z.object({
  relationType: z.enum(['CLIENT', 'LANDLORD', 'OEM']),
  orgId: z.uuid(),
  partnerOrgId: z.uuid(),
  notes: z.string().optional().nullable(),
});

export type OrganizationRelationshipProps = z.infer<
  typeof organisationRelationshipPropsSchema
>;
